import { SessionState } from "../session.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { SessionStateEnum } from "../../../../orchestrator-api-client";

export const setWsEventQueueReducer = (
  state: SessionState,
  action: PayloadAction<SessionStateEnum>,
) => {
  if (action.payload) {
    state.wsEventsQueue = [...state.wsEventsQueue, action.payload];
  }
};

export const clearQueueReducer = (state: SessionState) => {
  state.wsEventsQueue = [];
};
